import { render, staticRenderFns } from "./AccessTable.vue?vue&type=template&id=47566a2f&scoped=true&"
import script from "./AccessTable.vue?vue&type=script&lang=js&"
export * from "./AccessTable.vue?vue&type=script&lang=js&"
import style0 from "./AccessTable.vue?vue&type=style&index=0&id=47566a2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47566a2f",
  null
  
)

export default component.exports